import React, {memo} from 'react';
import BackDrop from './BackDrop/BackDrop';
import './Modal.css'

const Modal = (props) => {
const {closeModal, showing} = props;
    return (
        <>
            <BackDrop show={showing} clicked={closeModal}/>
            <div
                className='custom-modal'
                style={{
                    transform: showing ? 'translateY(0)' : 'translateY(-100vh)',
                    opacity: showing ? '1' : '0'
                }}>
                {props.children}
            </div>
        </>
    );
};

export default memo(Modal, (prevProps, nextProps) => prevProps.showing === nextProps.showing);


